module.exports = __webpack_public_path__ + "img/skolundzic.b0852246.png";